<template lang="pug">
  .login-form
    .message-box(:class="{ alert: error.message }")
      p {{ $t(error.message) }}

    .login-from-box
      text-field-with-icon(
        name="mail"
        placeholder="メールアドレス"
        v-model="email"
        type="email"
        autocomplete="on"
        @input="onChange"
      )
      text-field-password(
        name="password"
        placeholder="パスワード"
        v-model="password"
        :secure="!isVisiblePassword"
        @input="onChange"
        @click="onVisiblePassword"
      )
</template>

<style lang="scss" scoped>
.login-form {
  .message-box {
    width: 100%;
    height: 40px;
    text-align: center;

    p {
      margin: 0;
      padding: 0;
      @extend %body-text;
      line-height: 40px;
    }
  }

  .alert {
    background: $color-alert;
  }

  .login-from-box {
    margin-top: 120px;
  }

  .sign-text-field {
    margin-top: 16px;
  }

  .labeled-check-box {
    text-align: right;
    margin: 24px 24px 0 0;
  }
}
</style>

<script>
import { mapActions } from 'vuex'
import TextFieldWithIcon from '@/components/molecules/TextFieldWithIcon'
import TextFieldPassword from '@/components/molecules/TextFieldPassword'
import SubmittableForm from '@/components/mixins/SubmittableForm'

export default {
  components: {
    TextFieldWithIcon,
    TextFieldPassword,
  },
  mixins: [SubmittableForm],
  data() {
    return {
      email: '',
      password: '',
      isVisiblePassword: false,
    }
  },
  methods: {
    ...mapActions('auth', ['login']),
    async submit() {
      this.error.message = ''
      return new Promise((resolve) => {
        this.login({ email: this.email, password: this.password })
          .then(resolve)
          .catch(this.handleError)
      })
    },
    onVisiblePassword() {
      this.isVisiblePassword = !this.isVisiblePassword
    },
    validate() {
      return this.email.length > 0 && this.password.length > 0
    },
  },
}
</script>
